export const NOTICE_VERSION = "2026-10-14.2";
export const LEGAL_CONTACT = "info@overton.solutions";

export const LegalSection = ({ id, title, children }) => (
  <section data-testid={`legal-section-${id}`} className="space-y-2">
    <h2 className="text-xs font-semibold leading-relaxed">{title}</h2>
    {children}
  </section>
);

export const LegalContact = ({ testId }) => (
  <a data-testid={testId} className="underline underline-offset-2 break-all" href={`mailto:${LEGAL_CONTACT}`}>{LEGAL_CONTACT}</a>
);

export const LegalDocument = ({ children, kind }) => (
  <div data-testid={`${kind}-terms-content`} className="space-y-5 text-xs leading-relaxed uppercase break-words text-neutral-700" style={{ letterSpacing: 0 }}>
    {children}
    <p data-testid="terms-effective-date" className="text-neutral-500">Effective 14 October 2026</p>
  </div>
);